import React from 'react';

export default function DiscoverIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={60}
      height={36}
      viewBox="0 0 60 36"
      {...props}
    >
      <defs>
        <rect id="discoverIconA" width={60} height={36} rx={4} />
        <path
          id="discoverIconB"
          d="M14.47 36H56c2.209 0 4-1.795 4-4.003V20.22S43.92 31.12 14.47 36z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <rect width={59} height={35} x=".5" y=".5" stroke="#E6E6E6" rx={4} />
          <use fill="#E6772F" xlinkHref="#discoverIconB" />
        </g>
        <path
          fill="#1A1919"
          d="M10.973 17.893c-.45.385-1.024.554-1.94.554h-.381V13.85h.38c.917 0 1.469.157 1.941.561.488.418.78 1.062.78 1.73 0 .669-.292 1.336-.78 1.751zm-1.657-5.22H7.235v6.952h2.069c1.1 0 1.896-.251 2.592-.804.828-.656 1.319-1.645 1.319-2.67 0-2.052-1.602-3.478-3.899-3.478zM13.868 12.673h1.412v6.952h-1.412zM18.747 15.338c-.852-.3-1.101-.499-1.101-.874 0-.437.445-.768 1.057-.768.424 0 .773.162 1.146.56l.737-.926a3.246 3.246 0 0 0-2.133-.772c-1.285 0-2.265.856-2.265 1.987 0 .961.455 1.448 1.785 1.911.555.185.838.311.98.397.284.175.425.426.425.716 0 .566-.468.981-1.101.981-.674 0-1.22-.322-1.546-.929l-.913.847c.653.915 1.436 1.324 2.514 1.324 1.47 0 2.507-.942 2.507-2.284 0-1.105-.48-1.607-2.092-2.17M21.284 16.15c0 2.045 1.677 3.629 3.835 3.629.609 0 1.13-.115 1.773-.405v-1.598c-.568.546-1.066.762-1.71.762-1.427 0-2.437-.988-2.437-2.397a2.36 2.36 0 0 1 2.374-2.386c.672 0 1.185.228 1.773.782V12.94c-.62-.3-1.13-.425-1.744-.425-2.146 0-3.864 1.615-3.864 3.635M38.37 17.34l-1.938-4.667h-1.544l3.079 7.127h.76l3.139-7.127h-1.533L38.37 17.34M42.508 19.625h4.018v-1.178h-2.6V16.57h2.5v-1.177h-2.5V13.85h2.6v-1.178h-4.018v6.952M49.293 15.87h-.412v-2.103h.435c.885 0 1.359.356 1.359 1.033 0 .696-.474 1.07-1.382 1.07zm2.84-1.146c0-1.301-.932-2.05-2.568-2.05h-2.104v6.95h1.42V16.83h.184l1.958 2.795h1.742l-2.285-2.93c1.068-.209 1.654-.907 1.654-1.97z"
        />
        <path
          fill="#E6772F"
          d="M35.087 16.167c0 2.001-1.694 3.623-3.786 3.623s-3.787-1.622-3.787-3.623c0-2.002 1.695-3.624 3.787-3.624 2.092 0 3.786 1.622 3.786 3.624"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/DiscoverIcon.svg.jsx